import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/img/Warning.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "100",
  height: "100",
  alt: "Logo"
}, null, -1)
const _hoisted_2 = { class: "popUpDD" }
const _hoisted_3 = { style: {"color":"#00805d"} }
const _hoisted_4 = { style: {"color":"#00805d"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: true,
    modal: "",
    closable: false,
    header: "Importante",
    draggable: false,
    id: "p-dialog"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        icon: "pi pi-times",
        onClick: $props.UploadFile,
        id: "question-pro-continuar",
        text: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Continuar →")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        icon: "pi pi-times",
        onClick: $setup.CancelarTransmision,
        text: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode("← Volver")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_row, {
        gutter: 24,
        justify: "space-evenly"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xs: 4,
            sm: 4,
            md: 4,
            lg: 4,
            xl: 4
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 20,
            sm: 20,
            md: 20,
            lg: 20,
            xl: 20
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("p", null, [
                  _createTextVNode("Realizarás la transmisión para el empleador identificado con "),
                  _createElementVNode("span", null, [
                    _createElementVNode("b", _hoisted_3, _toDisplayString($setup.tipoIdentificacion) + " " + _toDisplayString($setup.numeroIdentificacion), 1)
                  ]),
                  _createTextVNode(" para el periodo "),
                  _createElementVNode("span", null, [
                    _createElementVNode("b", _hoisted_4, _toDisplayString($props.year) + " - " + _toDisplayString($props.month), 1)
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}